import { render, staticRenderFns } from "./navbar-bottom.vue?vue&type=template&id=f60670ce"
import script from "./navbar-bottom.vue?vue&type=script&lang=js"
export * from "./navbar-bottom.vue?vue&type=script&lang=js"
import style0 from "./navbar-bottom.vue?vue&type=style&index=0&id=f60670ce&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports